import { useState } from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import CartScreenTouch from '../screens/CartScreenTouch';

export default function MobileCartModal(props) {
  const { cartShow, setCartShow, tableTemp, tableCode } = props;
  const [enterNameShow, setEnterNameShow] = useState(false);
  const [customerName, setCustomerName] = useState();

  return (
    <>
      <Modal show={cartShow} onHide={() => setCartShow(false)} centered>
        <Modal.Header closeButton></Modal.Header>
        <CartScreenTouch
          mobileCart={true}
          tableTemp={tableTemp}
          isCustomerOrder={false}
          height="100%"
          setCartShow={setCartShow}
        ></CartScreenTouch>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
}
